/** Display format for read-only audit date/time fields on forms. */
export const AUDIT_DISPLAY_FORMAT = 'DD-MM-YYYY HH:mm:ss';

/** All audit field keys (matches GenWebApi BaseDto). */
export const AUDIT_FIELD_KEYS = [
    'createdOn',
    'createdBy',
    'createdDate',
    'updatedOn',
    'updatedBy',
    'updatedDate',
    'updatedTime',
];
